import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dfd7576"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "VvicList viewport" }
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "describtion" }
const _hoisted_5 = { class: "list" }
const _hoisted_6 = { class: "rel" }

import { ref, onMounted } from 'vue'
import ProductList from '../components/productList.vue'
import GoodsItem from '@/components/common/GoodsItem.vue'
import { VVICmodelvalprops } from '../const'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { useRequest } from '@/util/useLoading'
import { marketSearchGoods } from '@/apis/market'
import { t } from '@/plugins/i18n'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const searchParams = ref<VVICmodelvalprops>({})
const productResult = ref<any>({})
const route = useRoute()
const store = useStore()
const [loading, marketSearchGoodsApi] = useRequest(marketSearchGoods)
const title = ref('')
onMounted(async () => {
  const { cateCode, cateName }: any = route.query
  const res = await marketSearchGoodsApi({ cateCode })
  title.value = cateName ?? ''
  productResult.value = {
    records: res.data
  }
})

return (_ctx: any,_cache: any) => {
  const _component_member_event_box = _resolveComponent("member-event-box")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(title.value), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('根据商品上款量、收藏量、销量等数据计算')), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(ProductList, {
        pageNum: searchParams.value.pageNum,
        "onUpdate:pageNum": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.pageNum) = $event)),
        pageSize: searchParams.value.pageSize,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.value.pageSize) = $event)),
        data: productResult.value
      }, {
        default: _withCtx(({ item }) => [
          _createVNode(_component_member_event_box, {
            subscript: false,
            stopPropagation: !_unref(store).getters.isLogin,
            "observe-listen": true
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                (item.sort < 4 && item.sort)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["rank", `rank${item.sort}`])
                    }, "#" + _toDisplayString(item.sort), 3))
                  : _createCommentVNode("", true),
                _createVNode(GoodsItem, {
                  style: {"width":"219.5px"},
                  item: item,
                  showChannel: 1
                }, null, 8, ["item"])
              ])
            ]),
            _: 2
          }, 1032, ["stopPropagation"])
        ]),
        _: 1
      }, 8, ["pageNum", "pageSize", "data"])
    ])
  ], 512)), [
    [_directive_loading, _unref(loading)]
  ])
}
}

})